export default "__VITE_ASSET__DcrdzOgs__"